<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <dropdown :class="['mr-1']" :items="yPositions" v-model="yPos" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mx-1']" :items="xPositions" v-model="xPos" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <container align="center">
          <btn @click="snackbar = true" color="white" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" icon-left="notification-clear-all" :color-lightness="null">Show Snackbar</btn>
        </container>
        <snackbar @input="log('input', 'snackbar', snackbar)" :x-position="xPos[0]" :y-position="yPos[0]" v-model="snackbar">{{ $lang.iAmASnackbar }}</snackbar>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageSnackbar',
  mixins: [
    methods
  ],
  data () {
    return {
      snackbar: false,
      xPos: ['center'],
      yPos: ['bottom'],
      yPositions: ['top', 'bottom'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      }),
      xPositions: ['left', 'center', 'right'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  },
  watch: {
    xPos () {
      this.snackbar = false
      this.$nextTick(() => {
        this.snackbar = true
      })
    },
    yPos () {
      this.snackbar = false
      this.$nextTick(() => {
        this.snackbar = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/snackbar.vue